function initializeSwiper() {
  const swiper = new Swiper(".list_swiper", {
    loop: true,
    observer: true,
    observeParents: true,
    scrollbar: {
      el: '.swiper-scrollbar',
    },
  });
}

// 一覧カードの2枚目以降のスライド画像（card-image-osmosis の defer）を、
// スワイプ開始 or ホバーしたカードだけ読み込む。全カード分を初期表示で読むと
// iOS Safari でメモリ不足になりタブが落ちるため。
// フィルタ・ページ送りでグリッドが差し替わっても効くよう document で委譲する。
function loadDeferredCardImages(event) {
  const swiperEl = event.target.closest && event.target.closest(".list_swiper");
  if (!swiperEl) return;
  swiperEl.querySelectorAll("img[data-deferred-img]").forEach(img => {
    if (img.dataset.srcset) img.srcset = img.dataset.srcset;
    if (img.dataset.src) img.src = img.dataset.src;
    img.removeAttribute("data-deferred-img");
  });
}
document.addEventListener("pointerdown", loadDeferredCardImages, { passive: true });
document.addEventListener("touchstart", loadDeferredCardImages, { passive: true });
document.addEventListener("mouseover", loadDeferredCardImages, { passive: true });

window.addEventListener("load", () => {
  initializeSwiper();
  delaySwiper();
});

function delaySwiper(){
  document.querySelectorAll('.card__inner').forEach(itemCard => {
    const swipers = itemCard.querySelectorAll('.item_swiper');
    const swiperInstances = Array.from(swipers).map(swiperElement => {
        return new Swiper(swiperElement, {
            loop: true,
            scrollbar: {
                el: '.swiper-scrollbar',
            },
        });
    });
    const collection_swiper2 = new Swiper(".collection_swiper", {
      loop: true,
      slidesPerView: window.innerWidth <= 640 ? 2.4 : 6.3,
      freeMode: true,
      scrollbar: {
        el: '.swiper-scrollbar',
      },
    });

    const colorButtons = itemCard.querySelectorAll('.colorButtons button');
    if(colorButtons){
      colorButtons.forEach((button, index) => {
          button.addEventListener('click', () => {
              swipers.forEach((swiper, swiperIndex) => {
                  if (swiperIndex === index) {
                      swiper.classList.add('on');
                  } else {
                      swiper.classList.remove('on');
                  }
              });
          });
      });
    }
  });
}


const collection_swiper = new Swiper(".collection_swiper", {
  loop: true,
  slidesPerView: window.innerWidth <= 640 ? 2.4 : 6.3,
  freeMode: true,
  scrollbar: {
    el: '.swiper-scrollbar',
  },
});


document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll(".card_image").forEach(card => {
    let images = card.querySelectorAll(".slide_image");
    if (images.length > 0) {
      let randomIndex = Math.floor(Math.random() * images.length);
      images.forEach((img, index) => {
        if (index !== randomIndex) {
          img.remove(); // ランダムに選ばれなかった画像を削除
        }
      });
    }
  });
});

//価格スライダー設置
function createPriceSlider() {
  const priceSlider = document.getElementById("price_slider");
  const inputMin = document.querySelector('.ps_price-input-min');
  const inputMax = document.querySelector('.ps_price-input-max');

  if (priceSlider.noUiSlider) return;
  if (priceSlider) {
    noUiSlider.create(priceSlider, {
      start: [ Number(inputMin.value.replace(/,/g, "")),  Number(inputMax.value.replace(/,/g, ""))],
      connect: true,
      step: 500,
      range: {
        'min': 0,
        'max': Number(inputMax.dataset.max.replace(/,/g, "")),
      },
    });
  }
  let hasInitialized = false;

  priceSlider.noUiSlider.on('update', function (values, handle) {
    if (!hasInitialized) return; // ← 最初のupdateは無視

    if (handle === 0) {
      inputMin.value = Math.trunc(values[0]);
      inputMin.dispatchEvent(new Event('input', { bubbles: true }));
    }
    if (handle === 1) {
      inputMax.value = Math.trunc(values[1]);
      inputMax.dispatchEvent(new Event('input', { bubbles: true }));
    }
  });

  // 少し遅らせてフラグをオン
  requestAnimationFrame(() => {
    hasInitialized = true;
  });
}